import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {doNotTranslate} from "@khan/i18n";

export default function AIGuideTitle() {
    return (
        <HeadingSmall style={styles.header} tag="h2">
            <View style={styles.pillWrapper}>{doNotTranslate`Khanmigo`}</View>
        </HeadingSmall>
    );
}

const styles = StyleSheet.create({
    header: {
        color: color.offBlack,
    },
    pillWrapper: {
        flexDirection: "row",
    },
});
